import { component } from "picoapp";
import "slick-carousel";
import $ from "jquery";

export default component(() => {
  $(".testimonial-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true,
    prevArrow: ".prevarrow2",
    nextArrow: ".nextarrow2",
    dots: false,
    responsive: [
      {
        breakpoint: 580,
        settings: {
          dots: true,
          autoplay: true,
          arrows: false,
        },
      },
    ],
  });
});
